import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import KetaKiinnostaa from './KetaKiinnostaa';

ReactDOM.render(<KetaKiinnostaa />, document.getElementById('root'));
